import { AppException } from './AppException';

export class ModelException extends AppException {
  public readonly name: string;
  public readonly methodName: string;
  public readonly args: unknown;

  constructor(
    name: string,
    methodName: string,
    args: unknown,
    err: Error,
    data: unknown,
    sendToSentry = true,
  ) {
    super(err, data, sendToSentry);
    this.name = name;
    this.methodName = methodName;
    this.args = args;
  }

  get extras(): any {
    return {
      type: 'Model',
      model: this.name,
      methodName: this.methodName,
      args: this.args,
    };
  }

  static from(
    name: string,
    methodName: string,
    args: Record<string, unknown>,
    err: unknown,
    data: unknown,
    sendToSentry = true,
  ): ModelException {
    return new ModelException(name, methodName, args, err as Error, data, sendToSentry);
  }
}
